import { render } from "./zpCouponspayModel.vue?vue&type=template&id=3397d0c4"
import script from "./zpCouponspayModel.vue?vue&type=script&lang=js"
export * from "./zpCouponspayModel.vue?vue&type=script&lang=js"

import "./zpCouponspayModel.vue?vue&type=style&index=0&id=3397d0c4&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__